export class APIStatusError extends Error {
  response: Response
  constructor(response: Response) {
    super(`The API returned a status of ${response.status}`)
    this.response = response
  }
}
